/**
 * Market-applicability predicate shared by the filters and segments
 * catalogs (spec: _vdocs/superpowers/specs/2026-08-10-market-scoped-filters-design.md).
 *
 * - Empty SELECTION → allow: transient boot/URL states must never blank the panel.
 * - Empty/missing DESCRIPTOR → deny: an entity that declares no markets is
 *   offered nowhere, so a silent wire-contract change hides everything
 *   (unmissable) instead of showing everything (invisible).
 * - Otherwise the entity must be applicable in EVERY selected market —
 *   intersection semantics, matching the server's FilterAccessChecker rule.
 *
 * SYSTEM segments are the one exception (their empty `markets` means "all
 * markets" by contract) — callers bypass them BEFORE this predicate.
 */
export function isAvailableInSelectedMarkets(
  descriptorMarkets: number[] | undefined,
  selectedMarketIds: number[],
): boolean {
  if (selectedMarketIds.length === 0) return true;
  if (!descriptorMarkets || descriptorMarkets.length === 0) return false;
  return selectedMarketIds.every((m) => descriptorMarkets.includes(m));
}
